<template>
    <div>
        <div class="about-banner">
            <img src="../assets/img/dq.png" />
            <div class="about-banner-word" v-if="false">
                <span>关于我们 About Us</span>
                <img src="../assets/img/fb.png" />
            </div>
        </div>
        <div class="news-change-title">
            <a href="javascript:;" class="news-change-item" v-for="(item,index) in menu_active" :key="index" :class="{'selected':item.isActive}" @click="changeTab(index)">{{item.title}}</a>
            
        </div>
        <div class="news-change-content" style="display:block;">
            <h3 class="detail-title">工作概括</h3>
            <div class="detail-content">北京德源兴业投资管理有限公司党委现有直属党（总）支部17个，在职、离、退休党员346名。多年来，德源兴业党委始终认真贯彻落实中央精神和区委、区国资委党委的工作部署，围绕企业中心工作，发挥党组织的政治核心作用，不断加强企业党组织的队伍建设、组织建设、思想建设、反腐倡廉建设和制度建设。在引导全体党员、干部做好本职工作的同时，着力构建服务型、学习型、创新型党组织，全面提升党建工作科学化水平，同时充分发挥群团组织优势，不断为企业营造积极向上的舆论氛围、凝聚发展合力，为开创集团各项工作新局面提供了有力保障。
            </div>   
        </div>
        <div class="news-change-content" style="display:none;">
            <div class="news-change-list"v-for="(item,index) in new_work5" :key="index">
                 <img :src="baseUrl+item.cover">
                <div class="news-change-list-content">
                    <h4>{{item.desc}}</h4>
                    <div>
                        <span>{{item.addtime}}</span>
                        <a href="javascript:;" @click="toDetail(item.new_id)">了解详情</a>
                    </div>
                </div>
            </div>
            <a class="loading-more" @click="clickGetMore(model5,'model5')">{{model5.loadingText}}</a>
        </div>
        <div class="news-change-content" style="display:none;">
             <div class="news-change-list" v-for="(item,index) in new_work6" :key="index">
                <img :src="baseUrl+'/'+item.cover" />
                <div class="news-change-list-content">
                    <h4>{{item.desc}}</h4>
                    <div>
                        <span>{{item.addtime}}</span>
                        <a href="javascript:;" @click="toDetail(item.new_id)">了解详情</a>
                    </div>
                </div>
            </div>
            <a class="loading-more" @click="clickGetMore(model6,'model6')">{{model6.loadingText}}</a>
        </div>
    </div>
</template>

<script>

export default {
    data(){
        return {
            model4: {
                //党章党规
                type: 4,
                page: 1, //当前页数
            },
            new_work: '',
            model5: {
                //理论文章
                type: 5,
                page: 1, //当前页数
                loadingText:'点击加载更多'
            },
            new_work5: '',
            model6: {
                //组织活动
                type: 6,
                page: 1, //当前页数
                loadingText:'点击加载更多'
            },
            new_work6: '',
            menu_active:[
                 {
                    title: '工作状况',
                    link: '',
                    isActive: true,
                },
                {
                    title: '党建工作',
                    link: '',
                    isActive: false,
                },
                {
                    title: '群团工作',
                    link: '',
                    isActive: false,
                },
            ],
        }
    },
    methods:{
        changeTab:function (tabIndex){
            var that = this;
            var tabCardCollection = document.querySelectorAll(".news-change-content"),
            len = tabCardCollection.length;
            for(var i = 0; i < len; i++) {
                tabCardCollection[i].style.display = "none";
                that.menu_active[i].isActive = false;
            }
            that.menu_active[tabIndex].isActive = true;
            tabCardCollection[tabIndex].style.display = "block";
        },
        moreNews:function(){
            var that = this;
                that.$http.post(that.baseUrl+that.config.moreNews,that.$qs.stringify(that.model4)).then(function(ev){
                    // console.log(ev);
                    if(ev.data.code == 100){
                        that.new_work = ev.data.data;
                    }
                }).catch(function(error){
                    console.log(error);
                })

                that.$http.post(that.baseUrl+that.config.moreNews,that.$qs.stringify(that.model5)).then(function(ev){
                    console.log(ev.data.data);
                    if(ev.data.code == 100){
                        that.new_work5 = ev.data.data.data;
                    }
                }).catch(function(error){
                    console.log(error);
                })

                that.$http.post(that.baseUrl+that.config.moreNews,that.$qs.stringify(that.model6)).then(function(ev){
                    // console.log(ev);
                    if(ev.data.code == 100){
                        that.new_work6 = ev.data.data.data;
                    }
                }).catch(function(error){
                    console.log(error);
                })
        },
        clickGetMore:function(model,modelname){
            var that=this;
            model.page++;
            console.log(model);
            that[modelname].loadingText="加载中...";
            that.$http.post(that.baseUrl+that.config.moreNews,that.$qs.stringify(model)).then(function(ev){
                if(ev.data.code == 100){
                    that[modelname] = that[modelname].concat(ev.data.data.data);
                    that[modelname].loadingText="点击加载中";
                }else{
                    that[modelname].loadingText="已加载全部";
                }
            }).catch(function(error){
                console.log(error);
            })
        },
        toDetail: function(new_id){
            this.$router.push({
                name: 'newsContent',
                params: {
                    new_id: new_id
                }
            })
        }
    },
    mounted(){
        this.baseUrl = window.baseUrl;
        this.config = window.config;
        this.moreNews();
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/dangQun.vue